import { render } from "./RepairController.vue?vue&type=template&id=eb845f22"
import script from "./RepairController.vue?vue&type=script&lang=js"
export * from "./RepairController.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ravanjeyhan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__